import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getNotifications } from '../../helpers/api_helper';

const NotificacionesCobranzaHooks = () => {
    const [notificaciones, setNotificaciones] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);

    useEffect(() => {
        const fetchNotificaciones = async () => {
            setLoading(true);
            setError(null);
            try {
                const filters = { module: 'contabilidad', type: 'email' };
                const response = await getNotifications({ tenantId, ...filters, empresa });
                console.log('Response from API:', response);
                if (Array.isArray(response)) {
                    setNotificaciones(response);
                } else {
                    throw new Error('API returned invalid data format: expected an array');
                }
            } catch (err) {
                setError(`Failed to fetch notificaciones: ${err.message || 'Unknown error'}`);
                setNotificaciones([]);
            } finally {
                setLoading(false);
            }
        };

        if (tenantId) {
            fetchNotificaciones();
        }
    }, [tenantId, empresa]);

    return { notificaciones, loading, error };
};

export default NotificacionesCobranzaHooks;